import DettaglioAgente from 'views/App/Agenti/DettaglioAgente.jsx'
import DettaglioCliente from 'views/App/Clienti/DettaglioCliente.jsx'

import Calendario from 'views/App/Calendario/Calendario.jsx'

import DateRange from 'material-ui-icons/DateRange'

var detailRoutes = [
  { 
    path: '/agenti/:id',
    name: 'Dettaglio Agente',
    component: DettaglioAgente,
  }, { 
    path: '/clienti/:id',
    name: 'Dettaglio Cliente',
    component: DettaglioCliente,
  },
  {
    path: '/calendario',
    name: 'Calendario',
    icon: DateRange,
    component: Calendario,
  }
]

export default detailRoutes


// WEBPACK FOOTER //
// ./src/routes/detail.jsx